<template>
  <div class="card overflow-hidden p-4 pt-0">

    <div v-if="loading">
      <TableBodyLoader :minHeight="1200" :offsetY="-240" message="상세정보를 불러오는 중..." />
    </div>

    <div v-else>
        <DetailHeader :headerTitle="'제품이력 상세'" :cardHeader="'pb-3 pt-4 ps-0'"/>
      <div
        class="page-header min-height-300 border-radius-xl opacity-8 page-header-fallback"
        :style="productInfo.mfId 
                ? { backgroundImage: `url('${manufactureInfo.bgImageUrl}')`,
                    backgroundPositionY: '50%' } 
                : { backgroundColor: '#f9f9f9' }"
      >
        <div class="position-absolute top-0 start-0 p-4">
          <h4 class="text-white">{{ productInfo.manufacturer?.name }}</h4>
        </div>
      </div>
      <div class="mx-4 card card-body blur shadow-blur" :class="productInfo.mfId ? 'mt-n6' : 'mt-4'">
        <div class="row gx-4">
          <div class="col-auto">
            <div class="avatar avatar-xl position-relative icon-fallback icon-hover-zoom">
              <img
                v-show="productInfo.imageUrl"
                :src="productInfo.imageUrl"
                alt="profile_image"
                class="shadow-sm w-100 h-100 border-radius-lg object-fit-cover"
              />
            </div>
          </div>
          <div class="col-auto my-auto">
            <div class="h-100">
              <h5 class="mb-1">{{productInfo.name}}</h5>
              <p class="mb-0 text-sm font-weight-bold">{{productUrn}}</p>
            </div>
          </div>
          <!-- <div
            class="mx-auto me-5 mt-3 col-lg-1 col-md-6 my-sm-auto ms-sm-auto"
          >
            <div class="nav-wrapper position-relative end-0">
              <ul
                class="p-1 bg-transparent nav nav-pills nav-fill"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="px-0 py-1 mb-0 nav-link active"
                    data-bs-toggle="tab"
                    href="javascript:;"
                    role="tab"
                    aria-selected="false"
                  >
                    <span class="ms-1">제품정보</span>
                  </a>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </div>


      <div class="py-4">
        <div class="mt-3 row">
          <div class="col-12 col-md-4 col-xl-4">
            <product-trace-qr-card
              title="QR 정보"
              :urn="productUrn"
              :qrAvgCnt="qrAvgCnt"
              :qrCurCnt="qrCurCnt"
              :qrPer="qrPer"
              :image="qrImageUrl"
            />
          </div>
          <div class="mt-4 col-12 col-md-4 col-xl-4 mt-md-0">
            <product-info-card
              title="제품 정보"
              :info="productInfo"
            />
          </div>
          <div class="mt-4 col-12 col-md-4 col-xl-4 mt-md-0">
            <manufacturer-card
              title="제조사 정보"
              :info="manufactureInfo"
            />
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-6 mt-2">
            <timeline-list
              title="타임라인"
            >
              <timeline-item
                v-for="trace in traceList" :key="trace.id"
                color="info"
                :icon="getIconByBizStep(trace.bizStep)"
                :title="trace.stepName"
                :date-time="formatDate(trace.eventTime)"
              />
            </timeline-list>
            <product-trace-card
              title="제조 이벤트"
              class="mt-4"
              :traceList="traceList"
            />
          </div>
          <div class="col-md-6 mt-2">
            <raw-material-card
                :rawMaterialList="rawMaterialList"
                @click-material="showMaterialInfo" />
            <!-- <ProductTraceFlowCard 
              class="mt-3"
              :traceList="traceList"
              :rawMaterialList="rawMaterialList" /> -->
            <div class="card shadow-sm p-4 mt-3" style="width: 100%;">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">위치정보</h6>
              </div>
              <div class="p-1">
                <map-arrow
                  :points="traceList"
                  :fitBounds="true"
                  :showSegmentDistance="true"
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { BIZ_STEP_ICON_MAP } from '@/constants/bizStepIconMap.js';
import DetailHeader from "@/components/DetailHeader.vue";
import SoftButton from "@/components/SoftButton.vue";
import TableBodyLoader from "@/components/loading/TableBodyLoader.vue";
import ManufacturerCard from '@/views/components/ManufacturerCard.vue';
import RawMaterialCard from '@/views/components/RawMaterialCard.vue';
//import ProductTraceFlowCard from '@/views/components/productTrace/ProductTraceFlowCard.vue';
import TimelineList from "@/views/components/TimelineList.vue";
import TimelineItem from "@/views/components/TimelineItem.vue";
import ProductTraceCard from "@/views/components/productTrace/ProductTraceCard.vue";
import ProductInfoCard from "@/views/components/productTrace/ProductInfoCard.vue";
import ProductTraceQrCard from "@/views/components/productTrace/ProductTraceQrCard.vue";
import MapArrow from "@/components/map/mapArrow.vue";
import api from '@/api/api';



export default {
  name: "ProfileOverview",
  components: {
    DetailHeader,
    SoftButton,
    ManufacturerCard,
    RawMaterialCard,
    //ProductTraceFlowCard,
    ProductTraceCard,
    ProductInfoCard,
    ProductTraceQrCard,
    TimelineList,
    TimelineItem,
    TableBodyLoader,
    MapArrow,
  },
  computed: {
  },
  data() {
    return {
      loading: false,
      mfId: '',
      productId: this.$route.query.id,
      productUrn: this.$route.query.urn,
      linkUrl: '',
      productInfo: {},
      manufactureInfo: {},
      qrImageUrl: null,

      traceList: [],
      rawMaterialList: [],

      qrAvgCnt: 0,
      qrCurCnt: 0,
      qrPer: 0,

      tracePoints: [
        { lat: 37.5665, lng: 126.9780, label: "제조(서울)" },
        { lat: 36.3504, lng: 127.3845, label: "포장(대전)" },
        { lat: 35.1796, lng: 129.0756, label: "출고(부산항)" },
        { lat: 35.9078, lng: 127.7669, label: "입고(국내센터)" },
      ],
    };
  },
  mounted() {
    const grpId = 1;
    const mfId = 8808123456;
    localStorage.setItem("grpId", grpId);
    localStorage.setItem("mfId", mfId);

    this.mfId = localStorage.getItem('mfId');
    this.init();
  },
  methods: {
    init(){
      this.fetchProductInfo();
      this.fetchTraceList();
      this.fetchTraceQr();
    },

    async fetchProductInfo() {
      this.loading = true;
      try {
        const [res] = await Promise.all([
          api.get(`/product`, { params: {
            id: this.productId,
            urn: this.productUrn
          }
        }),
          new Promise(r => setTimeout(r, 500))
        ]);
        const result = res.data?.result;
        this.linkUrl = result.url;
        this.productInfo = result.productInfo;
        this.manufactureInfo = result.manufactureInfo;
      } catch (e) {
        this.toastError?.("상세 조회 중 오류가 발생했습니다.");
      } finally {
        this.loading = false;
      }
    },

    async fetchTraceList() {
      try {
        const response = await api.get(`/productTrace/traceList?mfId=${this.mfId}&urn=${this.productUrn}`);
        const result = response.data.result;
        if(result.traceList && result.traceList.length > 0){
          this.traceList = result.traceList;
          this.rawMaterialList = result.rawMaterialList;
          
          this.qrAvgCnt = result.qrAvgCnt;
          this.qrCurCnt = result.qrCurCnt;
          this.qrPer = Math.min(Math.round(result.qrPer / 5) * 5, 100);
        }else{
          this.traceList = [];
          this.rawMaterialList = [];
          
          this.qrAvgCnt = 0;
          this.qrCurCnt = 0;
          this.qrPer = 0;
        }

      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    async fetchTraceQr() {
      try {
        const response = await api.get(`/productTrace/qr?urn=${this.productUrn}`, {
          responseType: 'blob' 
        });

        this.qrImageUrl = URL.createObjectURL(response.data);

      } catch (error) {
        console.error("통계 정보 불러오기 실패:", error);
      }
    },
    getIconByBizStep(bizStep) {
      return BIZ_STEP_ICON_MAP[bizStep] || 'ni-tag'; // fallback 아이콘
    },
    showMaterialInfo(id, sgtin){
      this.$router.push({ path: '/productTrace/material', query: { id: id, sgtin: sgtin, bgImageUrl: this.manufactureInfo.bgImageUrl ?? '' } })
    }
  }
};
</script>

<style scoped>
.page-header-fallback {
  min-height: 300px;
  background-color: #f0f0f0;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.8;
}
.icon-fallback {
  min-width: 64px;
  min-height: 64px;
  background-color: #f0f0f0;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}


</style>